import template from './lendingTab.html';
import './style.scss';

export default {
  template,
};
